export const GO_BACK_TEXT = 'COMMON:GO_BACK';
